/* eslint-env browser */
import * as React from 'react'

import { getCDNUrl } from '../../../../../../shared/services/media-helper'

const PropTypes = require('prop-types')
const classNames = require('classnames')
const placeholderUrl = 'https://statics.fishfriender.com/statics/placeholder_fish.png'

function getMediaUrl(oneSpecies) {
  let mediaUrl
  if ((oneSpecies.medias || []).length > 0) {
    mediaUrl = getCDNUrl(oneSpecies.medias[0], 'small', { name: oneSpecies.seoName, type: 'fishSpecies' })
  }
  if (!mediaUrl || mediaUrl.length === 0) {
    mediaUrl = placeholderUrl
  }
  return mediaUrl
}

class SpeciesGrid extends React.Component {
  constructor(props) {
    super(props)
    this.state = {}
  }

  render() {
    const { customItemClassName, species } = this.props

    return (
      <div className="columns is-mobile is-multiline is-gapless">
        {species.map(oneSpecies => (
          <div
            key={oneSpecies.id}
            className={classNames(
              'column',
              { 'is-6-mobile is-4-tablet is-4-desktop': !customItemClassName },
              customItemClassName
            )}
          >
            <figure className="image is-3by1">
              <a href={`/fish/${oneSpecies.seoName}`}>
                <img src={getMediaUrl(oneSpecies)} className="has-object-fit-contain" alt={oneSpecies.name} />
              </a>
            </figure>
            <div>
              <a
                href={`/fish/${oneSpecies.seoName}`}
                style={{ display: 'block' }}
                className="has-text-weight-bold has-text-break-word is-size-8"
              >
                {oneSpecies.name}
              </a>
            </div>
            <div className="is-size-8 has-text-grey has-text-break-word">
              {[oneSpecies.sciGenus, oneSpecies.sciSpecies, oneSpecies.sciAdditional]
                .filter(elt => !!elt && elt.length > 0)
                .join(' ')}
            </div>
          </div>
        ))}
      </div>
    )
  }
}

SpeciesGrid.propTypes = {
  species: PropTypes.array,
  customItemClassName: PropTypes.string,
}

SpeciesGrid.defaultProps = {
  species: [],
  customItemClassName: null,
}

module.exports = SpeciesGrid
